// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1f9Op","name":"styles_name__1Rmjl","phone":"styles_phone__H5RlX"};